<template>
  <div class="query" > 
    <a-spin :spinning="iconLoading"> 
    <Evenmenubar :title="title" :data1="uId" /> 
    <div class="d-flex flex-column min-vh-100" style="background: linear-gradient(-45deg, #ffffff, #d2edf8, #ffffff);    ">
        <div class="mt-2" style="margin:0px auto;max-width: 1024px;"  >
                <div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem; background: #fff; border-radius: 14px; padding: 0.35rem 0.5rem; box-shadow: 0 2px 10px rgba(0,0,0,0.10);">
                  <b-icon icon="search" style="color: #aaa; font-size: 1.1rem; margin-left: 0.3rem; flex-shrink: 0;"></b-icon>
                  <b-form-input
                    autocomplete="off"
                    @keyup.enter="handleEnterKey"
                    type="search"
                    v-model="uId"
                    placeholder="請輸入關鍵字或行政區域"
                    style="border: none; box-shadow: none; background: transparent; font-size: 15px; padding: 0.25rem 0.3rem; flex: 1; min-width: 0;">
                  </b-form-input>
                  <b-button
                    v-if="uId.length > 0"
                    @click="clearable()"
                    variant="link"
                    style="padding: 0.2rem 0.4rem; color: #bbb; flex-shrink: 0;">
                    <b-icon icon="x-circle-fill" font-scale="1.1"></b-icon>
                  </b-button>
                  <b-button
                    @click="dQueryMyItem(1)"
                    :disabled="uId.length == 0"
                    variant="success"
                    style="border-radius: 10px; padding: 0.35rem 1rem; font-weight: 600; flex-shrink: 0;">
                    <b-icon icon="play-circle" style="margin-right: 0.25rem;"></b-icon>搜尋
                  </b-button>
                  <b-button
                    @click="dQuery()"
                    variant="warning"
                    style="border-radius: 10px; padding: 0.35rem 0.9rem; font-weight: 600; flex-shrink: 0;">
                    <b-icon icon="sliders" style="margin-right: 0.25rem;"></b-icon>篩選
                  </b-button>
                </div>                      
            <Actitemlist class="contantdiv" :item="list" kinds="inside" show="0" :winsize="windowsize" />
            <a-button v-if="list.length>0"  style="margin: 20px;" :loading="iconLoading"  @click="getmore()" type="primary" shape="round" size="large" >
              <b-icon v-show="!iconLoading" style="margin-right: 0.3rem;" scale="1.1" icon="cloud-download" variant="light" />
              取得更多資料
            </a-button>
            <a-result v-if="!rShow"  title="無相關資料, 請確認查詢條件, 或活該活動已經結束了, 謝謝">
              <template #extra>
              </template>
            </a-result>           
        </div>
    </div>    
    <b-modal ref="my-query" size="lg" id="modal-1" title="條件查詢" @hide="onHide" centered hide-footer>
      <div style="padding: 0.75rem;">

        <!-- 區域條件 -->
        <div style="background: #f0f7ff; border-radius: 12px; padding: 1rem; margin-bottom: 1rem; border-left: 4px solid #1890ff;">
          <div style="display: flex; align-items: center; margin-bottom: 0.6rem;">
            <b-icon icon="geo-alt-fill" variant="primary" style="margin-right: 0.4rem; font-size: 1rem;"></b-icon>
            <span style="font-weight: 700; font-size: 15px; color: #1890ff;">區域條件</span>
          </div>
          <Addresscom @toaddress="toaddress" @get_data="get_data" :sizes="windowsize.width" />
        </div>

        <!-- 活動類別 -->
        <div style="background: #fffbf0; border-radius: 12px; padding: 1rem; margin-bottom: 1rem; border-left: 4px solid #faad14;">
          <div style="display: flex; align-items: center; margin-bottom: 0.6rem;">
            <b-icon icon="tag-fill" variant="warning" style="margin-right: 0.4rem; font-size: 1rem;"></b-icon>
            <span style="font-weight: 700; font-size: 15px; color: #d48806;">活動類別</span>
          </div>
          <Types @query="query" :sizes="windowsize.width" />
        </div>

        <!-- 已選條件摘要 -->
        <div style="background: #f6f6f6; border-radius: 12px; padding: 0.9rem 1rem; margin-bottom: 1rem;">
          <div style="font-weight: 700; font-size: 13px; color: #888; margin-bottom: 0.6rem; letter-spacing: 0.5px;">
            <b-icon icon="funnel-fill" style="margin-right: 0.3rem;"></b-icon>已選查詢條件
          </div>
          <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; min-height: 2rem; align-items: center;">
            <b-badge pill variant="primary" style="font-size: 13px; padding: 0.4rem 0.9rem;" v-if="raddress">
              <b-icon icon="geo-alt" style="margin-right: 0.3rem;"></b-icon>地區：{{ raddress }}
            </b-badge>
            <b-badge pill variant="warning" style="font-size: 13px; padding: 0.4rem 0.9rem;" v-if="reObj">
              <b-icon icon="tag" style="margin-right: 0.3rem;"></b-icon>分類：{{ reObj }}
            </b-badge>
            <b-badge pill variant="success" style="font-size: 13px; padding: 0.4rem 0.9rem;" v-if="sdate">
              <b-icon icon="calendar3" style="margin-right: 0.3rem;"></b-icon>時間：{{ showdate(sdate) }}
            </b-badge>
            <span v-if="!raddress && !reObj && !sdate" style="color: #bbb; font-size: 13px;">尚未選擇任何條件</span>
          </div>
        </div>

        <!-- 查詢按鈕 -->
        <b-button
          block
          size="lg"
          @click="dQueryMyItem(2)"
          style="border-radius: 10px; font-weight: 700; letter-spacing: 1px; height: 3rem;"
          :disabled="sdate == null && reObj == null && raddress == null"
          variant="primary">
          <b-icon icon="zoom-in" style="margin-right: 0.4rem;"></b-icon>開始查詢
        </b-button>

      </div>
    </b-modal>    
    <div class="wrapper flex-grow-1"></div>      
    <Efootbar /> 
  </a-spin>
  </div>
</template>
<script>
import * as moment from "moment/moment";
import Evenmenubar from '@/components/Querymenubar.vue'
import Efootbar from '@/components/Efootbar.vue'
import Actitemlist from '@/components/Actitemlist.vue' 
import Addresscom from "../components/Addresslistsimple.vue"
import Types from "../components/Types.vue"
import { actService } from '../_services'

const queryData = obj => {
  return actService.GetactItemsByOrg(obj) 
};  

export default {
  name: 'Querys',
  components: {
    Evenmenubar,
    Efootbar,
    Actitemlist, 
    Addresscom,   
    Types,
  }, 
  data() {
    return {
      kinds:1,
      showTop: false,  
      rShow: true,       
      title:{title:'活動查詢',logo:"house-fill"}, 
      iconLoading:false,  
      uId:'',
      raddress:null,
      reObj:null,
      sdate:null,
      objs: {},      
      list:[],
      page: 1,
      classtheme:null,
      queryState2: {},         
      windowsize: {
            width: 0,
            height: 0
        } 
    };
  },  
  mounted(){
    /*this.uId = this.$route.params.id
    if(this.uId!==null && this.uId!=='' ){        
        this.infiniteHandler()
    }*/
  },
  methods: {
    clearable(){
      this.uId=''
      if(this.list.length>0){
        this.iconLoading=true                
        setTimeout(() => {
          this.list=[]             
          this.iconLoading=false     
        }, 650);                
      }
    },
    handleEnterKey() {
      if(this.uId.length>0){
        this.dQueryMyItem(1)
      }
    },

    dQueryMyItem(val){
      this.list=[]
      this.page = 1
      this.kinds= val
      this.infiniteHandler() 
      if(val==2){
        this.$refs['my-query'].hide()
      } 
    },
    getmore(){
      this.infiniteHandler()
    },
    query(val){
      this.reObj = val.title
      this.classtheme = val.value==''?'': val.value
    },
    dQuery(){
      this.raddress=null
      this.classtheme=null                      
      this.sdate=null  
      this.reObj=null 
      this.$refs['my-query'].show()
    },
    toaddress(val){
      this.raddress = val==''?'': val
    },  
    get_data(val)   {
        var my_date = new Date();
        var first_date = new Date(my_date.getFullYear(), my_date.getMonth()-1, 1);
        this.sdate = val==''?first_date: val
        this.sdate = this.fdateformat(this.sdate)
    },     
    fetch(params = {}) {
      queryData({
        ...params,
      }).then(({ data }) => {
          this.objs = data;
      });
    },
    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm");
    },

    showdate(val){
        if(val!==null){
            return moment(val).format("YYYY-MM-DD");
        }
        return ' '
    },

    onHide(evt) {
          if(evt.trigger === "backdrop"){
              evt.preventDefault();
          }
      },
    handleResize() {
            this.windowsize.width = window.innerWidth;
            this.windowsize.height = window.innerHeight;
    },
    infiniteHandler() {  
        this.iconLoading = true   
        this.rShow = true
        var my_date = new Date();
        var first_date = new Date(my_date.getFullYear(), my_date.getMonth()-12, 1);       
        let params = {
            page: this.page,
            size: 3,
            title:this.uId=='' || this.uId==null ?null:this.uId,
            address:this.raddress=='' || this.raddress==null ?null:this.raddress,
            type: this.classtheme=='' || this.classtheme==null ?null:this.classtheme,                       
            date: this.sdate!=null? this.sdate:this.fdateformat(first_date),
            states:'Y',
            kinds:this.kinds
        }
        queryData({
          ...params,
        }).then(( { data }) => {
            let obj = data.data
            if (obj!=null) {
                this.page += 1;                
                setTimeout(() => {
                  this.list.push(...obj);
                  this.iconLoading=false     
                }, 650);

            }else{
              this.rShow = false
              this.iconLoading=false
            }
        });
    },    
    
  },
  destroyed() {
        window.removeEventListener('resize', this.handleResize);
  },  
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); 
    const savedQueryState = JSON.parse(window.sessionStorage.getItem('queryState2'));
    if (savedQueryState) {
      this.queryState2 = savedQueryState;
      this.page=this.queryState2.page
      this.uId=this.queryState2.title
      this.raddress=this.queryState2.address 
      this.classtheme=this.queryState2.classtheme
      this.kinds=this.queryState2.kinds
      this.list=this.queryState2.list
      window.sessionStorage.removeItem('queryState2');
    }       

  },
  
  beforeRouteLeave(to, from, next) {
    this.queryState2={
        page: this.page,
        title:this.uId,
        address:this.raddress,
        classtheme: this.classtheme,                       
        kinds:this.kinds,
        list:this.list,
    }
    window.sessionStorage.setItem('queryState2', JSON.stringify(this.queryState2));
    next();
  },    
}
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.sidenav {
  width: 230px;
  position: fixed;
  z-index: 1;
  top: 130px;
  right: 0;
  overflow-x: hidden;
  padding: 0;
}
.sidenav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  font-size: 25px;
  color: #2196F3;
  display: block;
}

.sidenav a:hover {
  color: #064579;
}
.applyfooter {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   height: 60px;
   background-color: #f0f8f8;
   color: #f0f8f8;
   text-align: center;
   
}
.ant-breadcrumb{
  color: #434242;
}
</style>

